import { useMemo } from 'react'
import UserRole from 'enums/UserRole'
import { usePageConfigUser } from 'hooks/usePageConfig'
import {
  useLiveReportSuggestedUserList,
  useLiveReportInfo
} from 'hooks/useLiveReportConfigModalState'
import { SuggestedUserInfo } from 'features/suggestedUsers/types'

const useLiveReportUserList = (subscribersIdList: Array<string>) => {
  const userConfig = usePageConfigUser()
  const liveReportSuggestedUserList = useLiveReportSuggestedUserList()
  const liveReportInfo = useLiveReportInfo()

  const suggestedUserList = useMemo(() => {
    if (liveReportSuggestedUserList && subscribersIdList) {
      return liveReportSuggestedUserList?.data
        ?.map((user) => ({
          ...user,
          label: `${user.userName} (${user.email})`,
          id: user.userProfileId
        }))
        .filter((user) => user.userRole !== UserRole.ROLE_ANNOTATOR)
        .filter((user) => !subscribersIdList.includes(user.userProfileId))
    }
    return []
  }, [liveReportSuggestedUserList, subscribersIdList])

  // initialize suggestedUserLookup
  const suggestedUserLookup = useMemo(() => {
    if (liveReportInfo && userConfig) {
      return new Map<string, SuggestedUserInfo>(
        liveReportSuggestedUserList?.data?.map((o) => [o.userProfileId, o])
      )
    }
    return new Map()
  }, [liveReportInfo, userConfig, liveReportSuggestedUserList])

  const annotatorList = Array.from(suggestedUserLookup.values())
    .filter((userInfo) => userInfo.userRole === UserRole.ROLE_ANNOTATOR)
    .map((item) => item.email)

  return { suggestedUserList, suggestedUserLookup, annotatorList }
}

export default useLiveReportUserList
